/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'

 
export const getAllAssetLocationUserList = createAsyncThunk('application/users/getAssetLocationUsers', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.assetLocation.getAssetLocationUsers()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})